import { render, staticRenderFns } from "./TypeDataTable.vue?vue&type=template&id=2085439d"
import script from "./TypeDataTable.vue?vue&type=script&lang=js"
export * from "./TypeDataTable.vue?vue&type=script&lang=js"
import style0 from "./TypeDataTable.vue?vue&type=style&index=0&id=2085439d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports